export default function serviceCompany() {
  return [
    'projectCards',
    'projectGrid',
    'projectDetails',
    'projectFeed',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/service-company.js